import * as React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { get } from 'lodash';

interface PrivateRouteProps {
  component?: any;
  path: string;
  exact: boolean;
}

const PrivateRoute = ({
  component: Component,
  path,
  exact,
  ...rest
}: PrivateRouteProps): React.ReactElement => {
  const isAuthenticated = useSelector((state) =>
    get(state, 'authReducer.isAuthenticated'),
  );
  return (
    <Route
      exact={exact}
      {...rest}
      path={path}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default React.memo(PrivateRoute);
